import { CAMPAIGN_STATUSES } from "../../utils/constants";

const ROWS_PER_PAGE = 10
export const FIRST_PAGE = 0

const OPTIONS_MENU = [{ 
    label: "Edit",
    visibility: "MERCH"
},
{
    label: "Resume",
    visibility: CAMPAIGN_STATUSES.paused
},
{
    label: "Pause",
    visibility: CAMPAIGN_STATUSES.live
},
{
    label: "Clone",
    visibility: "ALL"
}]

const COLUMNS = [
    { id: 'campaignId', label: 'Campaign ID', minWidth: 170 },
    { id: 'campaignName', label: 'Campaign Name', minWidth: 100 },
    {
        id: 'campaignDuration',
        label: 'Campaign Duration',
        minWidth: 170,
    },
    {
        id: 'createdBy',
        label: 'Created By',
        minWidth: 170,
    },
    {
        id: 'campaignStatus',
        label: 'Campaign Status',
        minWidth: 170,
        // align: 'right',
    },
    {
        id: 'options',
        label: '',
    },
];

export const CAMPAIGN_STATUS = {
    ready: 'Banner Ready',
    live: 'Live',
    requested: 'Requested',
}

const CAMPAIGN_VIEW_TYPES = [
    { type: 'all', label: 'All Campaigns' }, 
    { type: 'user', label: 'My Campaigns'}, 
    { type: 'requested', label:CAMPAIGN_STATUS.requested}, 
    { type: 'ready', label: CAMPAIGN_STATUS.ready}, 
    { type: 'live', label: CAMPAIGN_STATUS.live } 
];

export const CAMPAIGN_VIEW_TAB = {
  all: "all",
};

const CAMPAIGNS_XS = [2,3,2,3,2];

const DEFAULT_STATE = {
    page: 0,
    searchByCampaignName: "",
    searchByCampaignId: "",
    disableApply: false,
    selectedViewCampaign: 'all',
    selectedIndex: -1
}

const CAMPAIGN_POPOVER_MENU_ACTIONS = {
    CLONE: 'Clone',
    RESUME: 'Resume',
    PAUSE: 'Pause'
}

export default {
    ROWS_PER_PAGE,
    FIRST_PAGE,
    COLUMNS,
    DEFAULT_STATE,
    OPTIONS_MENU,
    CAMPAIGN_STATUS,
    CAMPAIGN_VIEW_TYPES,
    CAMPAIGNS_XS,
    CAMPAIGN_VIEW_TAB,
    CAMPAIGN_POPOVER_MENU_ACTIONS
}
